// src/store/slices/breakTimeLogSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import breakTimeLogApi from "api/breakTimeLogApi";

// export const fetchBreakLogs = createAsyncThunk(
//   "breakTimeLog/fetchAll",
//   async ({ page = 1, pageSize = 10, search = "", exclude_title = "" , title= "", employee="", date_range='', ...restFilters}, { rejectWithValue }) => {
//     try {
//       const res = await breakTimeLogApi.getAll(page, pageSize, search, exclude_title, title, employee, date_range, ...restFilters,);
//       return res;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.detail || "Failed to load break logs"
//       );
//     }
//   }
// );

export const fetchBreakLogs = createAsyncThunk(
  "breakTimeLog/fetchAll",
  async (
    {
      page = 1,
      pageSize = 10,
      search = "",
      exclude_title = "",
      title = "",
      employee = "",
      date_range = "",
      ...restFilters
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await breakTimeLogApi.getAll({
        page,
        pageSize,
        search,
        exclude_title,
        title,
        employee,
        date_range,
        filters: restFilters,
      });

      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to load break logs"
      );
    }
  }
);

export const fetchBreakLogsHide = createAsyncThunk(
  "breakTimeLog/fetchAllHide",
  async (
    {
      page = 1,
      pageSize = 10,
      search = "",
      exclude_title = "",
      title = "",
      employee = "",
      date_range = "",
      ...restFilters
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await breakTimeLogApi.getAll({
        page,
        pageSize,
        search,
        exclude_title,
        title,
        employee,
        date_range,
        filters: restFilters,
      });
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to load attendance logs"
      );
    }
  }
);

export const createBreakLog = createAsyncThunk(
  "breakTimeLog/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await breakTimeLogApi.create(data);
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to start break");
    }
  }
);

export const punchOutBreakLog = createAsyncThunk(
  "breakTimeLog/punchOut",
  async ({ id, punch_out }, { rejectWithValue }) => {
    try {
      const res = await breakTimeLogApi.update(id, { punch_out });
      return res;
    } catch (err) {
      return rejectWithValue("Failed to punch out");
    }
  }
);

export const deleteBreakLog = createAsyncThunk(
  "breakTimeLog/delete",
  async (id, { rejectWithValue }) => {
    try {
      await breakTimeLogApi.delete(id);
      return id;
    } catch (err) {
      return rejectWithValue("Failed to delete break log");
    }
  }
);

export const exportBreakLogs = createAsyncThunk(
  "breakTimeLog/export",
  async ({ title, exclude_title, ...restFilters }, { rejectWithValue }) => {
    try {
      const blob = await breakTimeLogApi.exportCsv(
        title,
        exclude_title,
        restFilters
      );
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `break-time-logs_${new Date()
        .toISOString()
        .slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      return { success: true };
    } catch (err) {
      return rejectWithValue("Export failed");
    }
  }
);

const breakTimeLogSlice = createSlice({
  name: "breakTimeLog",
  initialState: {
    logs: [],
    attendanceLogs: [],
    pagination: { count: 0, page_size: 10 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreakLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBreakLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchBreakLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchBreakLogsHide.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBreakLogsHide.fulfilled, (state, action) => {
        state.isLoading = false;
        state.attendanceLogs = action.payload.data || []; // ✅ SAFE
      })
      .addCase(fetchBreakLogsHide.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(createBreakLog.fulfilled, (state, action) => {
        state.logs.unshift(action.payload);
        state.pagination.count += 1;
      })
      .addCase(punchOutBreakLog.fulfilled, (state, action) => {
        const idx = state.logs.findIndex((l) => l.id === action.payload.id);
        if (idx !== -1) state.logs[idx] = action.payload;
      })
      .addCase(deleteBreakLog.fulfilled, (state, action) => {
        state.logs = state.logs.filter((l) => l.id !== action.payload);
        state.pagination.count -= 1;
      })
      .addCase(exportBreakLogs.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearError } = breakTimeLogSlice.actions;
export default breakTimeLogSlice.reducer;
